<template>
    <suspense>
      <template #default>
          <UserInfo :user="user"/>
      </template>
      <template #fallback>
        <Loading/>
      </template>
    </suspense>
</template>

<script>
import UserInfo from '../components/UserInfo.vue'
import Loading from '../components/Loading.vue'
//import Splash from '../components/Splash.vue'


export default {
  name: 'Home',
  components: {
    //Splash,
    UserInfo,
    Loading
  },
  props: {
    user: Object
  }
}
</script>

<style>

</style>
